import { type FC, memo } from 'react';
import { PackRarity } from 'global/constants';
import { type CollectionTagProps } from './types';

import {
  CollectionTag,
  ItemWrapper,
  CheckIconSVG,
} from './styled';

const CollectionTagItem: FC<CollectionTagProps> = ({ item, number }) => {
  const collectorProps: { background?: string, color?: string } = {};
  const iconProps: { color?: string } = {};
  switch (item) {
    case PackRarity.common:
      break;
    case PackRarity.rare:
      collectorProps.background = 'linear-gradient(76deg, #efd367 0%, #fff6d4 103%)';
      break;
    case PackRarity.legendary:
      collectorProps.background = 'linear-gradient(82deg, #eb67ef 0%, #f5dffc 46%, #75feff 77%, #eeffff 103%)';
      break;
    default:
      collectorProps.color = '#fff';
      collectorProps.background = 'linear-gradient(to right, #ff0f61, #fa6a04)';
      iconProps.color = '#fff';
  }

  return (
    <CollectionTag background={collectorProps.background} color={collectorProps.color}>
      <ItemWrapper data-test-id="item_wrapper">
        <CheckIconSVG color={iconProps.color} />
        <span>{number && number > 1 ? `${item} X${number}` : item}</span>
      </ItemWrapper>
    </CollectionTag>
  );
};

export default memo(CollectionTagItem);
